import type { IQuest } from 'components/quests/loyalty-quest/types';
import type { IConfigQuest, IQuestStep, ISystemwideQuest } from 'generated/sanity-graphql';

type CmsQuestWithRules = Pick<ISystemwideQuest | IConfigQuest, 'questRules'>;

const getAllCmsQuestSteps = (quest: CmsQuestWithRules): IQuestStep[] => {
  const directSteps = (quest.questRules?.steps ?? []).filter(
    (step): step is IQuestStep => step != null
  );
  const tierSteps = (quest.questRules?.tiers ?? [])
    .flatMap(tier => tier?.steps ?? [])
    .filter((step): step is IQuestStep => step != null);
  return [...directSteps, ...tierSteps];
};

export const getQuestStepRules = (quest: CmsQuestWithRules) =>
  getAllCmsQuestSteps(quest).flatMap(step => step.rules ?? []);

export const isPurchaseQuest = (quest: CmsQuestWithRules): boolean => {
  const allSteps = getAllCmsQuestSteps(quest);
  if (!allSteps.length) {
    return false;
  }
  return allSteps.every(step =>
    getQuestStepRules({ questRules: { steps: [step] } }).some(
      rule => rule?.__typename === 'SubtotalSpend'
    )
  );
};

export const getProductRequirementCmsIds = (quest: IQuest | undefined): string[] => {
  if (!quest || !quest?.steps) {
    return [];
  }

  const allCartReqs = quest.steps.flatMap(step => step.cartRequirements ?? []);
  const allProdReqs = allCartReqs.flatMap(cartReq => cartReq ?? []);
  const ids = allProdReqs.flatMap(req => (req?.id ? [req.id] : []));

  return Array.from(new Set(ids));
};
